module.exports = __webpack_public_path__ + "assets/img/5.776cd081.png";